import styled from '@emotion/styled';
import { Text } from 'app/components/Typography/Text';

export const FormTitle = styled(Text)`
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.03em;
  text-align: center;
`;

export const WrapperFormTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const WrapperItem = styled.div`
  background: #fff;
  margin-top: 24px;
  border-radius: 4px;
  border: 1px solid rgba(196, 200, 208, 1);
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
`;

export const WrapperTitle = styled.div`
  margin-bottom: 20px;
`;

export const Block = styled.div`
  padding: 16px;
  border-radius: 4px;
  border: 1px solid rgba(196, 200, 208, 1);
  display: inline-flex;
  width: 100%;
`;
